module.exports = __webpack_public_path__ + "img/9791158880910.ef1b195c.jpg";